import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import Box from '@mui/material/Box';

import { METADATA } from '../../constants';
import Footer from '../../components/HomeComponents/Footer';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FFF',
    height: '100%'
  },
  innerContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    padding: '150px',

    [theme.breakpoints.down('sm')]: {
      padding: '50px'
    }
  },
  successCheckoutImage: {
    // padding: '50% 0px !important',
    position: 'relative !important',
    top: 'unset !important',
    left: 'unset !important',
    height: 'auto !important',
    width: 'auto !important',
    display: 'flex !important',
    justifyContent: 'center !important'
  },
  headerTitle: {
    marginBottom: '50px',
    fontWeight: 'bold',
    fontSize: '40px',

    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      textAlign: 'center'
    }
  },
  subtitleContent: {
    fontSize: '1.5rem',
    marginBottom: '30px',

    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '0px 10%',
      textAlign: 'center'
    }
  }
}));

export default function PrivacyInfo() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.PRIVACYINFO.description} />
        <title>{METADATA.PRIVACYINFO.title}</title>
      </Helmet>
      <Box sx={{ flexGrow: 1, height: '100%' }}>
        <div className={classes.innerContentContainer}>
          <div>
            <h1 className={classes.headerTitle}>Privacy Info</h1>
            <p className={classes.subtitleContent}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
              when an unknown printer took a galley of type and scrambled it to make a type 
              specimen book. It has survived not only five centuries, but also the leap into 
              electronic typesetting, remaining essentially unchanged. It was popularised in 
              the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
              and more recently with desktop publishing software like Aldus PageMaker including 
              versions of Lorem Ipsum.
            </p>
            <p className={classes.subtitleContent}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
              when an unknown printer took a galley of type and scrambled it to make a type 
              specimen book. It has survived not only five centuries, but also the leap into 
              electronic typesetting, remaining essentially unchanged. It was popularised in 
              the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
              and more recently with desktop publishing software like Aldus PageMaker including 
              versions of Lorem Ipsum.
            </p>
          </div>
        </div>
      </Box>
      <Footer />
    </div>
  )
}